<template>
  <div class="container portfolio-list">
          <template v-if="tokens.length">
            <md-list class="scrollbar transparent">
                <template v-for="(token, i) in tokens">
                  <md-list-item class="portfolio-list__item"
                                :class="{ 'selected': selected && selected.code === token.code }"
                                @click="selectToken(token)"
                                :key="i">
                    <md-avatar class="item__avatar">
                      <template v-if="token.logoUrl">
                        <img :src="token.logoUrl" :alt="avatar(token.code)">
                      </template>
                      <template v-else>{{ avatar(token.code) }}</template>
                    </md-avatar>
                    <div class="item__details">
                      <span class="text_large">
                        {{ token.code }}
                        <company-name-getter :id="token.owner" />
                      </span>
                      <div>
                        <div class="text_x_small">
                          <span>{{ i18n.lbl_available() }}:</span>
                          <span>{{ token.availableBalance }} {{ token.code }}</span>
                          <span>~</span>
                          <span>{{ token.convertedBalance }} {{ token.convertedAsset }}</span>
                        </div>
                        <div class="text_x_small">
                          <span>{{ i18n.lbl_locked() }}:</span>
                          <span>{{ token.lockedBalance }} {{ token.code }}</span>
                        </div>
                      </div>
                    </div>
                  </md-list-item>
                </template>
            </md-list>
          </template>
  </div>
</template>

<script>
import { i18n } from '@js/i18n'
import CompanyNameGetter from '../common/CompanyNameGetter'
export default {
  components: { CompanyNameGetter },
  props: ['tokens'],
  data: _ => ({
    selected: null,
    i18n
  }),
  created () {
  },
  computed: {
  },
  methods: {
    avatar (code) {
      return code.length <= 2 ? code : code.charAt(0)
    },
    selectToken (token) {
      this.selected = token || null
      this.$emit('show-details', token)
    }
  },
  watch: {
    tokens () {
      this.selectToken(this.tokens[0])
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~scss/variables.scss';
  @import '~scss/mixins.scss';

  .portfolio-list {
    width: 100%;

    &__item {
      height: 122px;
      padding: 12px 0;
      &:not(:first-child) {
        border-top: 1px solid $col-border;
      }

      @include respond-to(medium) {
        height: 92px;
      }
    }

    & .item {

       &__avatar {
        width: 80px;
        height: 80px;
        min-width: 80px;
        min-height: 80px;
        border-radius: 50%;
        margin-right: 18px;

         @include respond-to(medium) {
           width: 60px;
           height: 60px;
           min-width: 60px;
           min-height: 60px;
           margin: 0 12px 0 0;
         }
      }

      &__details {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;

        & * {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/portfolio/Portfolio.List.vue